module.exports = __webpack_public_path__ + "static/media/wq.e91b3c35.svg";